import type { ToastItem } from "../hooks/useToast";

interface ToastStackProps {
  toasts: ToastItem[];
  onDismiss: (id: number) => void;
}

const ICON = { success: "✓", error: "⚠", info: "ℹ" } as const;

export function ToastStack({ toasts, onDismiss }: ToastStackProps) {
  if (toasts.length === 0) return null;
  return (
    <div className="toast-stack">
      {toasts.map((t) => (
        <div key={t.id} className={`toast toast--${t.type}`} onClick={() => onDismiss(t.id)} role="status">
          <span>{ICON[t.type]}</span>
          <span>{t.message}</span>
        </div>
      ))}
    </div>
  );
}
